<template lang="pug">
.guide
  .guide-kv
    .guide-kv-image
      img.guide-kv-img(src="/static/images/manual/guide_kv.webp")
    .guide-kv-underWrapper
      .guide-kv-parallelBox
        .guide-kv-parallelBox-sidePanel
        .guide-kv-parallelBox-articleMainContents
          h2.guide-kv-parallelBox-articleMainContents-text 取引先と新規の同時通知
  .guide-breadcrumb(v-for="page in pages")
    .guide-breadcrumb-child
      a.guide-breadcrumb-child-link(:href="page.indexLink") 通知設定
      p.guide-breadcrumb-child-slach &nbsp;/&nbsp;
      p.guide-breadcrumb-child-current 取引先の登録
  .guide-parallelBox
    .guide-sidePanel
      dl.guide-sidePanel-inner(v-for="list in sideContents")
        dt.guide-sidePanel-section
          .guide-sidePanel-section-title {{ list.sidePanelSection }}
          dd.guide-sidePanel-article(v-for="title in list.articleList")
            a.guide-sidePanel-article-link(:href="title.articlelink" :class="{ '-isCurrent': title.isCurrent}") {{ title.articleText }}

    .guide-articleMainContents
      .guide-articleMainContents-inner
        .guide-articleMainContents-headLineWrap
            h3.guide-articleMainContents-headLineWrap-headLine 取引先の登録
        .guide-articleMainContents-contents
          p.guide-articleMainContents-textDetail まずは、取引先の社名を登録するところから始めましょう。
          .guide-articleMainContents-titleText
            p.guide-articleMainContents-titleText-title 登録企業管理機能の設定
            p.guide-articleMainContents-titleText-text どのページでも表示される画面右上のユーザー名部分をクリックすると、複数のメニューが表示されます。
          .guide-articleMainContents-image(v-if="identifier () === 'kobot'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/kobot/guide_3d_01.webp")
          .guide-articleMainContents-image(v-else-if="identifier () === 'mynavi'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/mynavi/guide_3d_01.webp")
          .guide-articleMainContents-image(v-else)
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/guide_3d_01.webp")
          p.guide-articleMainContents-textOnly
            | この右上メニューの中にある「登録企業管理」 をクリックしてください。
            br
            | 「登録企業管理」をクリックすると、画面が切り替わります。
          .guide-articleMainContents-image(v-if="identifier () === 'kobot'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/kobot/guide_3d_02.webp")
          .guide-articleMainContents-image(v-else-if="identifier () === 'mynavi'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/mynavi/guide_3d_02.webp")
          .guide-articleMainContents-image(v-else)
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/guide_3d_02.webp")
          p.guide-articleMainContents-textOnly
            | 画面の中央にある入力欄に取引先の企業名を一社ずつ改行しながら記載して、右下の「更新する」ボタンをクリックしてください。これで取引先の社名登録が完了します。
            br
            | さらに、入力欄下部の「上記の企業を検索対象に含める」の右にあるスイッチをクリックして「ON」に変更し、もう一度、「更新する」をクリックすることで、「取引先の求人のみ」通知する設定が完了します。
          .guide-articleMainContents-image(v-if="identifier () === 'kobot'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/kobot/guide_3d_03.webp")
          .guide-articleMainContents-image(v-else-if="identifier () === 'mynavi'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/mynavi/guide_3d_03.webp")
          .guide-articleMainContents-image(v-else)
            img.guide-articleMainContents-image-img(src="/static/images/manual/job_notification_settings/guide_3d_03.webp")
          p.guide-articleMainContents-textOnly
            | ※この機能をONにすると、「求人検索」ページでも、「取引先の求人のみ」表示される状態になります。
            br
            | ※機能をOFFにして、「更新する」ボタンをクリックすれば「取引先の求人含めた全ての求人」が表示される状態に戻ります。
      .guide-articleMainContents-movePage(v-for="page in pages")
        a.guide-articleMainContents-movePage-container.-pageBack(:href="page.backLink")
          .guide-articleMainContents-movePage-container-outer
            .guide-articleMainContents-movePage-container-inner
              .guide-articleMainContents-movePage-container-textArea
                p.guide-articleMainContents-movePage-container-title {{ page.backPageTitle }}
                p.guide-articleMainContents-movePage-container-text {{ page.backPageText }}
              .guide-articleMainContents-movePage-container-image
                img.guide-articleMainContents-movePage-container-img(src="/static/images/manual/guide_icon_arrow.svg")
        a.guide-articleMainContents-movePage-pageIndex(:href="page.indexLink")
          .guide-articleMainContents-movePage-pageIndex-outer
            .guide-articleMainContents-movePage-pageIndex-inner
              .guide-articleMainContents-movePage-pageIndex-image
                img.guide-articleMainContents-movePage-pageIndex-img(src="/static/images/manual/guide_icon_index.svg")
              p.guide-articleMainContents-movePage-pageIndex-title 通知設定一覧
        a.guide-articleMainContents-movePage-container.-pageNext(:href="page.nextLink")
          .guide-articleMainContents-movePage-container-outer
            .guide-articleMainContents-movePage-container-inner
              .guide-articleMainContents-movePage-container-textArea
                p.guide-articleMainContents-movePage-container-title {{ page.nextPageTitle }}
                p.guide-articleMainContents-movePage-container-text {{ page.nextPageText }}
              .guide-articleMainContents-movePage-container-image
                img.guide-articleMainContents-movePage-container-img(src="/static/images/manual/guide_icon_arrow.svg")
</template>

<script>
export default {
  data () {
    return {
      job_notification_settings: '',
      headLineTitle: '',
      textOnly: '',
      image: '',
      titleTextTitle: '',
      titleTextText: '',
      isCurrent: '',
      sideContents: [
        {
          sidePanelSection: '1. 通知メールの設定',
          articleList: [
            {
              articlelink: '/guide/job_notification_settings/1-a',
              articleText: 'a. 通知機能の概要',
            },
            {
              articlelink: '/guide/job_notification_settings/1-b',
              articleText: 'b. 検索条件の保存',
            },
            {
              articlelink: '/guide/job_notification_settings/1-c',
              articleText: 'c. 通知設定の作成',
            },
            {
              articlelink: '/guide/job_notification_settings/1-d',
              articleText: 'd. 通知設定の変更',
            },
          ],
        },
        {
          sidePanelSection: '2. 取引先の求人通知',
          articleList: [
            {
              articlelink: '/guide/job_notification_settings/2-a',
              articleText: 'a. 通知される求人のイメージ',
            },
            {
              articlelink: '/guide/job_notification_settings/2-b',
              articleText: 'b. 取引先の登録',
            },
            {
              articlelink: '/guide/job_notification_settings/2-c',
              articleText: 'c. 社数が多い場合の対応方法',
            },
          ],
        },
        {
          sidePanelSection: '3. 取引先と新規の同時通知',
          articleList: [
            {
              articlelink: '/guide/job_notification_settings/3-a',
              articleText: 'a. 通知される求人のイメージ',
            },
            {
              articlelink: '/guide/job_notification_settings/3-b',
              articleText: 'b. アカウントごとの役割整理',
            },
            {
              articlelink: '/guide/job_notification_settings/3-c',
              articleText: 'c. 取引先の除外',
            },
            {
              isCurrent: true,
              articlelink: '/guide/job_notification_settings/3-d',
              articleText: 'd. 取引先の登録',
            },
          ],
        },
      ],

      pages: [
        {
          backLink: '/guide/job_notification_settings/3-c',
          backPageTitle: '3. 取引先と新規の同時通知',
          backPageText: 'c. 取引先の除外',
          indexLink: '/guide/job_notification_settings',
          nextLink: '/guide/job_notification_settings/1-a',
          nextPageTitle: '1. 通知メールの設定',
          nextPageText: 'a. 通知機能の概要',
        },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/guide/job-notification-settings/overview/3-d.vue